import React from 'react';
import { trpc } from '../../../services/trpc';

export default function useCreateIdentityVerificationLinkToken({ app, email, identityId, templateId }) {
  const { mutateAsync } = trpc.deprecated.plaid.createIdentityVerificationLinkToken.useMutation();

  return React.useCallback(
    (forceReset) => {
      return mutateAsync({
        app,
        email,
        forceReset: !!forceReset,
        identityId,
        templateId,
      });
    },
    [app, email, identityId, mutateAsync, templateId]
  );
}
